import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import PracticeFormStyle from '../styles&pics/PracticeFormStyle';

function PracticeForm() {
  const navigate = useNavigate();
  const min = 1;
  let [max, setMax] = useState(224);

  const handleChange = (event) => {
    const table = event.target.value;
    if (table === 'eidikes') {
      setMax(174);
    } else {
      setMax(224);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const eidos = formData.get('eidos');
    const erid = formData.get('erid');
    
    navigate(`/PracticeQForm?eidos=${eidos}&erid=${erid}`);
  };

  return (
    <>
      <PracticeFormStyle />
      <div className="practice-container">
        <div className="practice-card">
          <h1>Εξάσκηση στις ερωτήσεις πιστοποίησης.</h1>
          <h2>
            Εδώ μπορείτε να επιλέξετε μια από τις γενικές ή ειδικές ερωτήσεις πιστοποίησης και 
            εφόσον δώσετε την απάντησή σας να λάβετε το αποτέλεσμα και την σωστή απάντηση.
          </h2>
          <form id="f1" className="form" onSubmit={handleSubmit}>
            <label htmlFor="eidos">Επιλέξτε τον τύπο της ερώτησης:</label>
            <label htmlFor="vasikes">
              <input 
                type="radio" 
                name="eidos" 
                id="vasikes" 
                value="vasikes" 
                onChange={handleChange} 
                required 
              />
              <span>Γενικές</span>
            </label>
            <label htmlFor="eidikes">
              <input 
                type="radio" 
                name="eidos" 
                id="eidikes" 
                value="eidikes" 
                onChange={handleChange} 
                required
              />
              <span>Ειδικές</span>
            </label>
            <label htmlFor="erid">
              Εισάγετε τον αριθμό της ερώτησης που επιθυμείτε{' '}
              <i>
                (μπορείτε να επιλέξετε ανάμεσα σε 224 γενικές και 174 ειδικές 
                πληκτρολογώντας τον αριθμό ερώτησης στο πλαίσιο)
              </i>:
              <input 
                id="erid" 
                type="number" 
                min={min} 
                max={max} 
                name="erid" 
                required 
              />
            </label>
            <input 
              type="submit" 
              value="Ας προχωρήσουμε στην εξάσκηση" 
              name="button" 
            />
          </form>
        </div>
      </div>
    </>
  );
}

export default PracticeForm;